module.exports = __webpack_public_path__ + "img/algodao.6eb3ec87.svg";